import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const Skills = () => {
  const ref = useIntersectionObserver();

  const skills = [
    'HTML & CSS',
    'JavaScript (ES6+)',
    'React.js & Next.js',
    'Python & FastAPI',
    'ASP.NET',
    'SQL & PostgreSQL',
    'Supabase',
    'AI & Machine Learning',
    'AI Chatbot Integration',
    'Bootstrap & Tailwind',
    'Git & CI/CD',
    'Graphic Designing',
    'Digital Marketing & SEO',
    'Wordpress Development',
    'Hostinger',
    'Video Editing'
  ];

  return (
    <section id="skills" className="section">
      <div ref={ref} className="container container-lg" data-animate>
        <h2>Skills</h2>
        <div className="skills-grid">
          {skills.map(skill => (
            <div key={skill} className="skill">{skill}</div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
